import React from 'react';
import Head from 'next/head';
import Link from 'next/link';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from '../../components/HeroSection';

const ArticlesIndex = () => {
  const articles = [
    {
      id: 'indesign-templates-automation',
      title: 'The Power of Adobe InDesign Templates for Automated Creative Asset Production',
      excerpt: 'Discover how utilizing Adobe InDesign documents as templates can revolutionize your creative asset production while maintaining brand integrity, unlike simple online editors.',
      date: 'June 30, 2025',
      readTime: '5 min read'
    },
    {
      id: 'affordable-creative-marketing-automation',
      title: 'Implementing On-Brand Creative Assets in Marketing Automation Without Breaking the Bank',
      excerpt: 'Learn how Personalia makes it easy to integrate highly creative, on-brand assets into your marketing automation and customer communication processes.',
      date: 'June 30, 2025',
      readTime: '5 min read'
    }
  ];

  return (
    <>
      <Head>
        <title>Articles | Personalia.io</title>
        <meta name="description" content="Explore articles about personalized creative asset automation, InDesign templates, and marketing integration with Personalia." />
      </Head>

      <Header />

      <HeroSection
        title="Articles & Insights"
        subtitle="Explore our latest articles, insights and thought leadership on personalized creative asset automation."
        imageUrl="/images/articles-hero.png"
        primaryCTA={{ text: "Contact", href: "/contact" }}
        secondaryCTAs={[
          { text: "Latest Articles", href: "#articles" }
        ]}
      />

      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {articles.map((article) => (
              <div key={article.id} className="bg-gray-50 rounded-lg shadow-sm overflow-hidden">
                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-2">
                    <span>{article.date}</span>
                    <span className="mx-2">•</span>
                    <span>{article.readTime}</span>
                  </div>
                  <h3 className="text-xl font-semibold mb-3">
                    <Link href={`/articles/${article.id}`} className="text-primary hover:text-primary-dark transition-colors">
                      {article.title}
                    </Link>
                  </h3>
                  <p className="text-gray-600 mb-4">{article.excerpt}</p>
                  <Link 
                    href={`/articles/${article.id}`} 
                    className="inline-flex items-center text-primary hover:text-primary-dark font-medium"
                  >
                    Read more
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ArticlesIndex;
